import { getCountries } from 'libphonenumber-js/min';
import { BLOCKED_COUNTRIES } from './constants';

// Checking if country is available for making calls
export const isCountryBlocked = countryCode => !!countryCode && BLOCKED_COUNTRIES.some(code => code === countryCode.toLowerCase());

// Checking if country is OFAC. OFAC is a list of countries that are under US sanctions
// https://app.asana.com/0/1202532337591475/1202532269017764
export const isOfacCountry = countryCode => {
  const OFAC_COUNTRIES = ['ir', 'cu', 'sy', 'kp'];
  return countryCode && !OFAC_COUNTRIES.includes(countryCode == null ? void 0 : countryCode.toLowerCase());
};

// Guard function for checking if country code is a valid libphonenumber country code
export function isPhoneNumberCountry(countryCode) {
  return getCountries().some(() => country => country === countryCode);
}

// Function used for autocomplete search
export function includesCaseInsensitive(a, b) {
  if (a === void 0) {
    a = '';
  }
  if (b === void 0) {
    b = '';
  }
  return !b || a.toLowerCase().indexOf(b.toLowerCase()) !== -1;
}
//# sourceMappingURL=utils.js.map